
import { Injectable } from '@angular/core';

@Injectable()
export class EventLoggerService {
    public logError(error: Error, message: string, data: any) { }
    public logMessage(message: string, data: any) { }
    public logUserAction(message: string, data: any) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/event-logger.service.ts